<app-alert class="fixed top-10 z-50 sm:right-[47px] sm:left-auto left-0 right-0 sm:mx-0 mx-auto"></app-alert>
<onafriq-spinner *ngIf="loaderService.isLoading | async" class="z-[60] fixed"></onafriq-spinner>
<router-outlet></router-outlet>
